const LOGS = [
    {
        id: "EVENT 04:12:07",
        text: "COFFEE SUBROUTINE FIRED FOUR HOURS EARLY. ENTIRE APARTMENT NOW OPERATES ON LOCAL MQTT PACKETS.",
        action: "ACTION TAKEN: NONE. COFFEE WAS GOOD.",
        tone: "text-slate-600",
    },
    {
        id: "EVENT 23:47:55",
        text: "TIMBOT REFACTORED THREE SCRIPTS, THEN SIMULATED A 3D TEAPOT FOR 45 CONSECUTIVE MINUTES.",
        action: "ACTION TAKEN: TEAPOT ARCHIVED.",
        tone: "text-slate-600",
    },
    {
        id: "LOG SLOT RESERVED",
        text: "[ FUTURE INCIDENT PENDING. BASED ON HISTORICAL DATA, NOT LONG. ]",
        action: "ACTION TAKEN: AWAITING INEVITABLE.",
        tone: "text-slate-500 italic",
    },
];

export default function EventLogSection() {
    return (
        <section id="logs" className="py-20 border-b border-subtle bg-[#f2f4f6]" data-testid="event-log-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="mb-10">
                    <span className="font-mono text-xs text-cyan-600 tracking-widest uppercase">
                        // Autonomous Event Log
                    </span>
                    <h2 className="font-display text-3xl font-bold text-slate-900 mt-1">Recent System Incidents</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {LOGS.map((log, i) => (
                        <div
                            key={log.id}
                            data-testid={`event-log-${i + 1}`}
                            className="p-6 rounded-lg bg-white border border-subtle font-mono text-xs flex flex-col justify-between"
                        >
                            <div>
                                <span className="text-cyan-600 block mb-3">{log.id}</span>
                                <p className={`${log.tone} leading-relaxed mb-6`}>{log.text}</p>
                            </div>
                            <span className="text-slate-500">{log.action}</span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
